module.exports = __webpack_public_path__ + "img/bs-vue.88f56806.png";